/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentProcessorEnum {
    PACE_EVEREST = 'Pace_Everest',
    PNP = 'PNP',
    TTECH = 'TTECH',
    PACE_TRANSAFE = 'Pace_Transafe',
    OTHER = 'Other',
    I3PAY_FAC = 'i3PayFac',
}